export default __webpack_public_path__ + "static/cbdVp8Bg-95d6a545118f2d49715b942c8daf0941.png";